import axios from "axios";
import { baseUrl } from "../../constants/constants";

export const axiosV3 = axios.create({
  baseURL: `${baseUrl}/v3`,
  headers: {
    Authorization: localStorage.getItem("amoozeshMeliToken")?.length ?? "",
  },
});

axiosV3.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err?.response.status === 401) {
      if (Boolean(localStorage.getItem("amoozeshMeliToken")) === false) {
        localStorage.removeItem("amoozeshMeliToken");
        return;
      }

      console.log("Logging Out ....");

      try {
        localStorage.removeItem("amoozeshMeliToken");
        axiosV3.get("/user/logout");
      } catch (err) {
      } finally {
        window.location.reload();
      }
    }

    return Promise.reject(err);
  }
);
